/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react'
import { ErrorMessage, useFormikContext } from 'formik'
import { useDropzone } from 'react-dropzone'
import { minioSingleFileUpload } from 'containers/events/Api'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { alertTypes } from 'constants/Common'
import GalleryUploadPanel from './GalleryUploadPanel'

function GalleryStep() {
  const formik = useFormikContext()
  const [fileLoading, setFileLoading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)

  const handleFileUpload = async (file) => {
    const formData = new FormData()
    formData.append('file', file, 'file')
    formData.append('project', 'xler')

    const fileType = file.type.split('/')[0]
    setFileLoading(true)

    const onProgress = (percent) => {
      setUploadProgress(percent)
    }

    const result = await minioSingleFileUpload(formData, onProgress)
    if (result?.message) {
      if (result?.paths) {
        if (fileType === 'video') {
          formik.setFieldValue('gallery', [
            ...(formik.values.gallery || []),
            { imageUrl: '', vidUrl: result.paths, name: file.name },
          ])
        }
        if (fileType === 'image') {
          formik.setFieldValue('gallery', [
            ...(formik.values.gallery || []),
            { imageUrl: result.paths, name: file.name, vidUrl: '' },
          ])
        }
      }
      setFileLoading(false)
      setUploadProgress(0)
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.message || 'Successfully!'}
        />
      )
    } else {
      setFileLoading(false)
      setUploadProgress(0)
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const onDrop = useCallback(
    (files) => {
      if (files.length > 0) {
        Array.from(files).forEach((file) => {
          handleFileUpload(file)
        })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const removeFile = (file, type) => {
    const updatedArray = formik.values[type].filter(
      (item) => item.imageUrl !== file.imageUrl || item.vidUrl !== file.vidUrl
    )
    formik.setFieldValue(type, updatedArray)
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/svg+xml, image/png, image/jpeg, image/gif, video/*',
    maxSize: 50 * 1024 * 1024,
    onDropRejected: (fileRejections) => {
      fileRejections.forEach((rejection) => {
        rejection.errors.forEach((error) => {
          if (error.code === 'file-too-large') {
            toast(
              <CustomToast
                variant={alertTypes.DANGER}
                message={`File too large: ${rejection.file.name} please upload file size less than 50mb`}
              />
            )
          }
        })
      })
    },
  })

  return (
    <div className='event-create-card'>
      <p className='heading-lg mb-3'>Gallery</p>
      <GalleryUploadPanel
        inputValue={formik.values.galleryInput}
        onInputChange={formik.handleChange}
        onAttachLink={() => {
          if (formik.values.galleryInput) {
            const newLink = {
              link: formik.values.galleryInput,
              name: formik.values.galleryInput,
            }
            formik.setFieldValue(
              'gallery',
              formik.values.gallery?.length > 0
                ? [...formik.values.gallery, newLink]
                : [newLink]
            )
            formik.setFieldValue('galleryInput', '')
          }
        }}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        loading={fileLoading}
        uploadProgress={uploadProgress}
        items={formik.values.gallery || []}
        onRemoveItem={(file) => removeFile(file, 'gallery')}
      />
      <ErrorMessage className='error-text' component='p' name='gallery' />
    </div>
  )
}

export default GalleryStep
